import React, {Component} from 'react'
import Helmet from "react-helmet";
import Logo from "../../assets/images/mobile-logo.png";
import {Icon, Row, Col, Divider, Spin, Button, message} from "antd";
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import noCom from "./images/no-company.png"
import {checkWxSub, handleWxCode, readToken} from "../../utills/wechatUtils";
class SubscribeBoxSearchList extends Component {
    state={
        boxNo:"",
        loading: false,
        orders:[],
        bt_disabled:true,
    }
    doSub=()=>{
        let wxToken = readToken();
        let token = wxToken.accessToken;
        let openId = wxToken.openid;
        let nickName = wxToken.nickname
        let address = wxToken.country+wxToken.province+wxToken.city

        this.state.orders.forEach((order)=>{
            if(order.checked){
                let params = new FormData();
                params.append("openid", openId)
                params.append("token", token)
                params.append("type", "box")
                params.append("nickName", nickName)
                params.append("address", address)
                params.append("value", order.boxNo)
                let result = ajax(baseUrl+"/d/public/subscribe",params,"POST");
                this.setState({
                    loading:true,
                })
                result.then((resp)=>{
                    if(resp&&resp.code>201){
                        message.info("订阅["+order.boxNo+"]失败\n"+resp.message)
                    }else{
                        message.info("订阅["+order.boxNo+"]成功")
                        setTimeout(()=>{this.props.history.push("/sub/box/")},200)
                    }
                }).catch(()=>{
                }).finally(()=>{
                    this.setState({
                        loading:false
                    })
                })
            }
        })


    }
    getOrderList= (boxNo) => {
        this.setState({
            loading:true,
        })
        if(boxNo) {
            let params={
                boxNo:boxNo
            }
            let result = ajax(baseUrl+'/d/public/sub/search/orders',params);
            result.then((resp)=>{
                if(resp.code === 200){
                    let orders = resp.data
                    orders.forEach((order)=>{
                        order.checked = false
                    })
                    this.setState({
                        orders:orders
                    })
                }else{
                    this.setState({
                        orders:[]
                    })
                }
            }).catch(()=>{
                this.setState({
                    orders:[]
                })
            }).finally(()=>{
                this.setState({
                    loading:false
                })
            })
        }
    }
    onClick=(order,index)=>{
        const newData = [...this.state.orders];
        const item = newData[index];
        let newItem = Object.assign(item,{})
        newItem.checked = !item.checked
        newData.splice(index, 1, {
            ...item,
            ...newItem,
        });
        let disabled = true
        for(let i=0;i<newData.length;i++){
            if(newData[i].checked){
                disabled=false
                break
            }
        }
        this.setState({
            orders: newData ,
            bt_disabled:disabled,
        });
    }
    research=()=>{
        this.props.history.push("/sub/box/search/")
    }
    componentDidMount() {
        handleWxCode(this.props).then((ret)=>{
            checkWxSub()
        }).catch((e)=>{
        })
        if(this.props.match.params) {
            const boxNo = this.props.match.params.boxNo
            this.setState({
                boxNo
            })
            this.getOrderList(boxNo)
        }
    }

    render() {
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网铁"
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                <div className='subscribe'>
                    <div className='subscribe-title'>
                        请选择所需关注的集装箱
                        <div className='subscribe-add' onClick={this.research.bind(this)}>
                            <Icon type="search" />
                            &nbsp;重新查询
                        </div>
                    </div>
                    <Spin size="large" spinning={this.state.loading}>
                        {this.state.orders && this.state.orders.length>0?
                            (<div>
                                {this.state.orders.map((order,key)=>(
                                <div className={order.checked?"subscribe-box checked":"subscribe-box unchecked"} key={key} onClick={this.onClick.bind(this,order,key)}>
                                <Row>
                                    <Col span={3}>
                                        <div className="subscribe-box-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20.262" height="11.671" viewBox="0 0 20.262 11.671">
                                                <g id="集装箱" transform="translate(-44.523 -121.487)">
                                                    <path id="路径_293" data-name="路径 293" d="M221.484,245.534a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,1,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,1,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.334,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Zm2.35,0a.324.324,0,0,1-.324-.324v-7.348a.324.324,0,0,1,.648,0v7.348a.324.324,0,0,1-.324.324Z" transform="translate(-173.841 -114.213)"/>
                                                    <path id="路径_294" data-name="路径 294" d="M63.7,121.487H45.6a1.081,1.081,0,0,0-1.081,1.081v9.51a1.081,1.081,0,0,0,1.081,1.081H63.7a1.081,1.081,0,0,0,1.081-1.081v-9.51A1.081,1.081,0,0,0,63.7,121.487Zm.005,10.6H45.6v-9.531H63.71v9.531Z" transform="translate(0)" />
                                                </g>
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col span={21}>
                                        箱号：{order.boxNo}
                                    </Col>
                                    <Divider style={{margin:"10px 0",display:"inline-block"}}/>
                                </Row>
                                <Row>
                                    <Col span={3}>
                                        <div className="subscribe-box-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.802" viewBox="0 0 16.5 16.802">
                                                <path id="铁路_1_" data-name="铁路 (1)" d="M88.335,80.757a.448.448,0,0,1-.193.045.432.432,0,0,1-.388-.236l-.315-.617H73.211l-.315.617a.437.437,0,0,1-.388.236.441.441,0,0,1-.193-.045.424.424,0,0,1-.2-.572l1.736-3.409a.439.439,0,0,1,.583-.191.424.424,0,0,1,.2.572l-.12.234H86.135l-.12-.234a.422.422,0,0,1,.2-.572.44.44,0,0,1,.583.191l1.736,3.409a.426.426,0,0,1-.2.572ZM86.57,78.244H74.08l-.435.853H87Zm-.908-1.652h-.5l.011.011H83.819l-.009-.011H77.219l-.009.011H75.854l.011-.011h-.591c-.24,0-.666-.364-.666-.6l.289-8.879a.878.878,0,0,1,.653-.78,19.182,19.182,0,0,1,3.19-.939,1.8,1.8,0,0,1,3.508.006,18.976,18.976,0,0,1,3.169.936.885.885,0,0,1,.653.78l.219,8.877A.8.8,0,0,1,85.663,76.592ZM83.771,75.6A1.054,1.054,0,1,0,82.7,74.544,1.061,1.061,0,0,0,83.771,75.6Zm-6.567,0a1.054,1.054,0,1,0-1.067-1.054A1.061,1.061,0,0,0,77.2,75.6Zm3.289-10.574a.752.752,0,1,0,.761.752A.758.758,0,0,0,80.493,65.024Zm4.446,2.758a.649.649,0,0,0-.653-.645,14.773,14.773,0,0,0-2.228-.5,1.793,1.793,0,0,1-3.128,0,14.7,14.7,0,0,0-2.243.5.649.649,0,0,0-.653.645l-.311,4.185a.432.432,0,0,0,.435.429h8.647a.433.433,0,0,0,.435-.429Z" transform="translate(-72.075 -64)"/>
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col span={21}>
                                        {order.originCountry}·{order.originCity}
                                        &nbsp;
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.652" height="6.063" viewBox="0 0 14.652 6.063">
                                            <g id="长箭头" transform="translate(-14.44 -309.495)">
                                                <path id="路径_295" data-name="路径 295" d="M14.44,490.254H23.9v.876H14.44Z" transform="translate(0 -178.138)" fill="#999"/>
                                                <path id="路径_296" data-name="路径 296" d="M673.811,309.495l5.093,2.991-5.093,3.072Z" transform="translate(-649.812)" fill="#999"/>
                                            </g>
                                        </svg>
                                        &nbsp;
                                        {order.destinationCountry}·{order.destinationCity}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={3}>
                                        <div className="subscribe-box-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                                <path id="时间" d="M28.035,22.578l-.49.78,2.791,1.751.49-.772-2.791-1.76Zm.428-3.25h-.918v4.03h.918ZM28,16.384a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,28,16.384Zm0,.918a5.582,5.582,0,1,1-5.582,5.582A5.584,5.584,0,0,1,28,17.3Z" transform="translate(-21.504 -16.384)"/>
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col span={21}>
                                        出发时间：{order.deliveryDt}
                                    </Col>
                                </Row>
                            </div>
                        ))}
                        </div>
                        )
                            :
                            <div className='subscribe-box-info'>
                                <img src={noCom}/>
                                <p>集装箱[{this.state.boxNo}]不存在</p>
                                <p>请确认后重新查询</p>
                            </div>
                        }
                    </Spin>
                </div>
                <Button className='subscribe-footer' disabled={this.state.bt_disabled} onClick={this.doSub}>
                    确认关注
                </Button>
            </div>

        )
    }
}
export default SubscribeBoxSearchList